export default "__VITE_ASSET__JCThDQNy__"